<template>
  <div>
    <b-row class="row pb-2">
      <b-col cols="12" sm="12" md="6">
        <div class="d-flex align-items-center">
          <div v-if="getIsInternational" class="d-flex align-items-center gap-1 pr-3">
            <span>Moeda&nbsp;</span>

            <div>
              <b-form-select
                v-model="selectedCurrency"
                size="sm"
                :options="optionsCurrency"
                class="ml-1"
              />
            </div>
          </div>

          <span>Mostrar&nbsp;</span>
          <div>
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            ></b-form-select>
          </div>
          <span>&nbsp;por página</span>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <div class="row">
      <div class="col-12">
        <div v-if="antecipations.length > 0 && !loading"
          class="table-responsive mb-0"
        >
          <b-table
            :items="antecipations"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            responsive="sm"
            sort-icon-left
          >
            <!-- Client -->
            <template v-slot:cell(_user)="data">
              {{ data.item.user.name }}<br />
              {{ data.item.user.email }}
              <br />
              {{ data.item.user.cellphone }}
            </template>
            <!-- Score -->
            <template v-slot:cell(_score)="data">
              <NewProgressBar v-if="data.item.user.score && data.item.user.score.total_score" :type="'SellerScore'" :valor="data.item.user.score.total_score"/>

            </template>
            <!-- Creation Date -->
            <template v-slot:cell(created_at)="data">
              {{ data.value | datetime }}
            </template>
            <!-- Status -->
            <template v-slot:cell(status)="data">
              {{ getStatusAntecipation(data.value) }}
            </template>
            <!-- Fee -->
            <template v-slot:cell(fee)="data">
              {{ data.item.currency_symbol }}
              {{ formatMoney(data.value) }}
            </template>
            <!-- Amount -->
            <template v-slot:cell(amount)="data">
              {{ data.item.currency_symbol }}
              {{ formatMoney(data.value) }}
            </template>
            <!-- Actions -->
            <template v-slot:cell(_actions)="data">
              <div v-if="showToAdminFinancial || compliance || risco || financialAssistant"
                class="d-flex actions"
              >
                <!-- Open SweetAlert2 Approve Anticipation -->
                <b-button
                  v-if="data.item.status === 'REQUESTED'"
                  v-b-tooltip.hover title="Aprovar esta antecipação"
                  variant="success"
                  class="mr-2"
                  @click="accept(data.item)"
                >
                  <i class="fas fa-check icon-costum"></i>
                </b-button>
                <!-- Open SweetAlert2 Refuse Anticipation -->
                <b-button
                  v-if="data.item.status === 'REQUESTED'"
                  v-b-tooltip.hover title="Recusar esta antecipação"
                  variant="danger"
                  @click="deny(data.item.id)"
                >
                  <i class="fas fa-times icon-costum"></i>
                </b-button>
              </div>
            </template>
            <!-- Details -->
            <template v-slot:cell(show_details)="data">
              <!-- Open Modal Details -->
              <b-button
                v-b-tooltip.hover title="Ver detalhes de antecipações"
                variant="dark"
                class="mr-2"
                @click="openModal(data.item)"
              >
                <i class="fas fa-eye"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <!-- Pagination -->
    <div v-if="antecipations.length > 0" class="row">
      <div class="col">
        <div
          class="dataTables_paginate paging_simple_numbers float-right"
        >
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- Feedback Menssage -->
    <div v-if="antecipations.length === 0 && !loading"
      class="row justify-content-center"
    >
      <div class="alert alert-primary" role="alert">
        Sem extrato financeiro.
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Money from '@src/mixins/money'
import validAcessRoute from '@src/utils/validAcessRoute'
import AntecipationService from '@services/resources/AntecipationService'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
import { mapGetters } from 'vuex';

var service = AntecipationService.build()

export default {
  name: "TableAnticipation",
  components: { NewProgressBar },
    mixins: [Money],
  props: {
    currency: {
      required: true,
      type: String,
      default: "BRL"
    },
  },
  data() {
    return {
      antecipations: [],
      client_id: -1,
      currentPage: 1,
      currencySymbol: "R$",
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: '_user', label: 'Cliente', sortable: false },
        { key: '_score', label: 'Score', sortable: false },
        { key: 'created_at', label: 'Data', sortable: false },
        { key: 'fee', label: 'Taxa', sortable: false },
        { key: 'amount', label: 'Valor', sortable: false },
        { key: 'status', label: 'Status', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
        { key: 'show_details', label: 'Detalhes', sortable: false },
      ],
      selectedCurrency: 0,
      optionsCurrency: [
        { value: 0, text: 'Todos' },
        { value: 1, text: 'BRL' },
        { value: 2, text: 'USD' },
        { value: 3, text: 'EUR'},
      ],
      loading: true,
      pageOptions: [20, 50, 100],
      perPage: 20,
      solicitation: {},
      sortBy: 'name',
      sortDesc: false,
      tabIndex: 0,
      totalRows: 1,
      // Actions Validate
      showToAdminFinancial: validAcessRoute(['administrator', 'financial', 'financialManager'], this.$store.getters.getProfile),
      compliance: validAcessRoute(['compliance'], this.$store.getters.getProfile),
      risco: validAcessRoute(['risk'], this.$store.getters.getProfile),
      financialAssistant: validAcessRoute(['financialAssistant'], this.$store.getters.getProfile),
    }
  },
  watch: {
    currentPage() {
      this.fetchAntecipations()
    },
    perPage() {
      this.fetchAntecipations()
    },
    selectedCurrency() {
      this.currentPage = 1
      this.fetchAntecipations()
    }
  },
  mounted() {
    this.fetchAntecipations();
    this.checkCurrency()
  },
  
  computed: {
    ...mapGetters({
      getIsInternational: 'getIsInternational',
    }),
  },

  methods: {
    getStatusAntecipation(type) {
      let t = ''
      if (type) {
        switch (type.toUpperCase()) {
          case 'ERRORED': t = 'ERRO'
          break
          case 'REFUSED': t = 'RECUSADO'
          break
          case 'APPROVED': t = 'APROVADO'
          break
          case 'AUTOMATICALLY_APPROVED': t = 'APROVADO AUTOMATICAMENTE'
          break
          case 'REQUESTED': t = 'REQUERIDO'
          break
          default: t = type
          break
        }
        return t
      } else return type
    },
    fetchAntecipations() {
      this.loading = true
      this.antecipations = []

      var data = {
        per_page: this.perPage,
        page: this.currentPage,
        currency_id: this.selectedCurrency
      }

      service
        .search(data)
        .then((resp) => {
          this.antecipations = resp.data
          this.totalRows = resp.total
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.loading = false
          if(this.antecipations) if(this.antecipations.length > 0) {
            this.$emit(
              'update-antecipations',
              this.antecipations[0].status === "REQUESTED",
              this.currency
            )
          }
        })
    },
    deny(id) {
      Vue.swal({
        title: 'Recusar Antecipação?',
        text: 'Tem certeza que deseja recusar essa solicitação de Antecipação? A mensagem informada será enviada para o solicitante',
        type: 'warning',
        showCancelButton: true,
        input: 'textarea',
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id,
            status: 'REFUSED',
            observation: result.value,
          }

          service
            .update(data)
            .then(() => {
              let myArray = this.antecipations;
              let cutID = parseInt(data.id);
              let index = myArray.findIndex((el) => el.id === cutID)
              this.antecipations[index].status = data.status;
              this.fetchAntecipations()
            })
            .catch(err => {
              console.error(err)
              Vue.swal({
                title: 'Saque',
                text: 'Ocorreu um erro durante o processo de recusar antecipação.',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              })
            })
        }
      })
    },
    accept(item) {
      Vue.swal({
        title: 'Aprovar Antecipação',
        text: 'Tem certeza que deseja aprovar esse Antecipação pendente?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            id: `${item.is_receivable ? 'receivable/' : ''}${item.id}`,
            status: 'APPROVED',
          }

          service
            .update(data)
            .then(() => {
              let myArray = this.antecipations;
              let cutID = parseInt(item.id);
              let index = myArray.findIndex((el) => el.id === cutID)
              this.antecipations[index].status = data.status;
              this.fetchAntecipations()
            })
            .catch((err) => {
              console.error(err)
              Vue.swal({
                title: 'Saque',
                text: 'Ocorreu um erro durante o processo de aprovar antecipação.',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              })
            })
        }
      })
    },
    openModal(data) {
      this.$emit('open-modal-details', data)
    },
    checkCurrency() {
      if(this.currency === "BRL") this.currencySymbol = "R$"
      if(this.currency === "USD") this.currencySymbol = "$"
      if(this.currency === "EUR") this.currencySymbol = "€"
      if(this.currency === "GBP") this.currencySymbol = "₤"
    },
  },
}
</script>

<style scoped>
  .icon-costum {
    width: 15px;
    height: 15px;
  }
</style>
